module.exports = __webpack_public_path__ + "static/media/DirtEW.cf06eacb.svg";